import angular from 'angular';

import OfficeFinancingController from './officeFinancingController';
import ACHController from './ach/achController';
import ACHDirective from './ach/achDirective';

import './checkUpload/checkUpload.scss'; // no controller
import PlaidFactory from './plaidFactory';

export default angular.module('app.accounts.offices.financing', [])
    .controller('OfficeFinancingController', OfficeFinancingController)
    .controller('AchController', ACHController)
    .factory('PlaidFactory', PlaidFactory)
    .directive('hpAch', ACHDirective)
    .run(($templateCache) => {
        $templateCache.put('app/accounts/offices/financing/officeFinancing.html', require('./officeFinancing.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/financing/viewFinancing.html', require('./viewFinancing.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/financing/ach/ach.html', require('./ach/ach.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/financing/checkUpload/checkUpload.html', require('./checkUpload/checkUpload.html')); // eslint-disable-line global-require
    })
    .name;




// WEBPACK FOOTER //
// ./src/app/accounts/offices/financing/index.js